<template>
  <VWidget
    :title="$t('Inventory')"
  >
    <v-layout
      slot="widget-content"
      row
      wrap
    >
      <v-flex
        xs12
        md6
      >
        <v-text-field
          v-model="product.sku"
          :label="$t('SKU')"
          outline
          class="mx-1"
        />
      </v-flex>
      <v-flex
        v-if="product.classification !== 'bundle'"
        xs12
        md6
      >
        <v-text-field
          v-model.number="product.inventory.quantity"
          :disabled="!isCreate()"
          :label="$t('Quantity')"
          outline
          class="mx-1"
        />
      </v-flex>
      <template v-if="!isCreate()">
        <v-flex
          v-if="product.classification !== 'bundle'"
          xs12
          md6
        >
          <v-text-field
            v-model="quantity"
            :label="$t('Restock/Deduct Quantity')"
            outline
            class="mx-1"
          />
        </v-flex>
        <v-flex
          v-if="product.classification !== 'bundle'"
          xs6
          md3
        >
          <v-btn
            :class="$vuetify.breakpoint.smAndDown ? 'ml-1' : ''"
            block
            large
            color="primary darken-1"
            @click="restock()"
          >
            {{ $t('Restock') }}
          </v-btn>
        </v-flex>
        <v-flex
          v-if="product.classification !== 'bundle'"
          xs6
          md3
        >
          <v-btn
            :class="$vuetify.breakpoint.smAndDown ? '' : ''"
            block
            large
            color="secondary darken-1"
            @click="deduct()"
          >
            {{ $t('Deduct') }}
          </v-btn>
        </v-flex>
      </template>
      <v-flex
        xs12
        md6
      >
        <v-text-field
          v-model="product.inventory.min_per_order"
          :label="$t('Min per order')"
          outline
          class="mx-1"
        />
      </v-flex>
      <v-flex
        xs12
        md6
      >
        <v-text-field
          v-model="product.inventory.max_per_order"
          :label="$t('Max per order')"
          outline
          class="mx-1"
        />
      </v-flex>
      <v-flex
        v-if="product.classification !== 'bundle'"
        xs12>

        <v-divider />
        <v-select
          v-model="product.inventory.policy"
          :items="[$t('continue'), $t('stop')]"
          :label="$t('Policy')"
          :hint="$t('Allow customers to purchase this product when out of stock')"
          class="mx-4 mt-4"
          color="primary"
          persistent-hint
        />
        <v-switch
          slot="activator"
          v-model="product.inventory.track"
          :label="$t('Track inventory')"
          class="mx-4"
          color="primary"
        />
        <v-switch
          slot="activator"
          v-model="product.inventory.is_restockable"
          :label="$t('Restockable Item')"
          class="mx-4"
          color="primary"
        />
        <v-switch
          slot="activator"
          v-model="product.inventory.is_bundle_exclusive"
          :label="$t('Bundle exclusive')"
          class="mx-4"
          color="primary"
        />
      </v-flex>
    </v-layout>
  </VWidget>
</template>

<script>
export default {
  name: 'ProductSingleInventory',

  props: {
    product: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      quantity: 0
    }
  },

  computed: {
    quantityWarningMessage () {
      return this.$t('Quantity won\'t change when product inventory is not tracked.')
    }
  },

  methods: {
    isCreate () {
      return this.$route.params.id === '__'
    },

    restock () {
      if (this.quantity === 0) {
        return
      }

      if (!this.canTrack()) {
        return this.$toast.warning(this.quantityWarningMessage)
      }

      this.product.restock(this.quantity)
        .then(() => {
          this.$toast(this.$t('Quantity updated'))
          this.quantity = 0
        }).catch(e => {
          this.$toast.error(this.$t(e.message))
        })
    },

    deduct () {
      if (this.quantity === 0) {
        return
      }

      if (!this.canTrack()) {
        return this.$toast.warning(this.quantityWarningMessage)
      }

      this.product.deduct(this.quantity)
        .then(() => {
          this.$toast(this.$t('Quantity updated'))
          this.quantity = 0
        }).catch(e => {
          this.$toast.error(this.$t(e.message))
        })
    },

    canTrack () {
      return this.product.inventory.track && !this.product.isDirty('inventory.track')
    }
  }
}
</script>
